import classNames from 'classnames'

import {useAppSelector} from '../../../../../../../hooks/react-redux'
import {getBuild} from '../../../../../../../selectors'
import type {BuildId} from '../../../../../../../types'

import {useDuration} from './RunTimeBar.hooks'

import styles from './RunTimeBar.css'

type Props = {
  runId: BuildId
}
const HUNDRED = 100

function RunTimeBar({runId}: Props) {
  const build = useAppSelector(state => getBuild(state, runId))
  const state = useAppSelector(state => getBuild(state, runId)?.state)
  const {percentageComplete} = build?.['running-info'] || {}

  const progressWidth = `${isNaN(percentageComplete ?? 0) ? 0 : Number(percentageComplete ?? 0)}%`
  const progressTextWidth = `${
    isNaN(percentageComplete ?? 0) ? 0 : Number((HUNDRED * HUNDRED) / (percentageComplete ?? 0))
  }%`

  const duration = useDuration(runId)

  const isRunning = state === 'running'

  return (
    <div className={styles.container}>
      <div className={styles.duration} style={{width: progressTextWidth}}>
        <div className={styles.wrapper}>
          {isRunning ? (
            <div
              className={classNames(styles.bar, styles.progress)}
              style={{width: progressWidth}}
            />
          ) : (
            <div className={classNames(styles.bar, styles.queue)} />
          )}
          <div
            className={classNames(styles.text, {
              [styles.textProgress]: isRunning,
            })}
          >
            {duration}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RunTimeBar
